import { render, staticRenderFns } from "./NotApproved.vue?vue&type=template&id=26e3c125&"
import script from "./NotApproved.vue?vue&type=script&lang=js&"
export * from "./NotApproved.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports